import { RestrictionFeature } from "./../../../../types";

export const getMessage = (
  data: RestrictionFeature.RestrictionBarData,
  restrictionContext: "Staff" | "Patron",
  formatCountLimit: (count: number, countLimit: number) => string
) => {
  let message = data.rule.displayName || data.rule.name;
  if (!!data.rule.countLimit) {
    message += `: ${formatCountLimit(
      data.count,
      data.rule.countLimit.countLimit
    )}`;
  }

  if (restrictionContext === "Patron" && !!data.rule.memberMessage) {
    message += ` - ${data.rule.memberMessage}`;
  }
  return message;
};
